export default {
  es: {
    operation: 'Operación',
    create: 'Crear paciente',
    name: 'Nombres',
    lastName: 'Apellidos',
    email: 'Correo electrónico',
    phoneNumber: 'Teléfono',
    document: 'Tipo y número de documento',
    type: 'Tipo',
    docType: 'Tipo de documento',
    number: 'Número',
    numberId: 'Número de documento',
    deletePatient: '¿Estás seguro de eliminar este paciente?',
    invitePatient: '¿Estás seguro de enviar invitación a este paciente?',
    resetPasswordPatient:
      '¿Estás seguro de reiniciar la contraseña de este paciente?',
    patientCreated: 'Un nuevo paciente ha sido creado',
    patientUpdated: 'Los datos han sido actualizados',
    patientDeleted: 'Un paciente ha sido eliminado',
    numRequired: 'El número es requerido',
    typeRequired: 'El tipo es requerido',
    clinicHistory: 'Historia clínica',
    invite: 'Invitar',
    medIndicator: 'Indicadores médicos',
    status: 'Estado',
    activo: 'Activo',
    inactivo: 'Inactivo',
    guest: 'Invitado',
    pending: 'Pendiente',
    invitation: 'Se ha enviado al paciente una invitación de registro.',
    alreadyInvited: 'Este paciente ya ha sido invitado.',
    documentType: 'Tipo documento identidad',
    insurance: 'Asegurador',
    insuranceCarrier: 'Aseguradora',
    kidneUnit: 'Unidad renal',
    clinic: 'Clínica',
    modality: 'Modalidad',
    start_date: 'Fecha Inicio',
    patient_status: 'Estado',
    end_date: 'Fecha Finalización',
    total_patients: 'Total Pacientes',
    patient_success: 'Exitosos',
    patient_failed: 'Errores',
    see_details: 'Ver Detalles',
    patientId: 'ID',
    process_date: 'Fecha Proceso',
    massive_processing: 'Procesamiento Masivo'
  },
  en: {
    operation: 'Operation',
    create: 'Create patient',
    name: 'Name',
    lastName: 'Lastname',
    email: 'Email',
    phoneNumber: 'Phone Number',
    document: 'Type and identification number',
    type: 'Type',
    docType: 'Tipo de documento',
    number: 'Number',
    numberId: 'Document number',
    deletePatient: 'Do you want to delete this patient?',
    invitePatient: 'Do you want to send an invitation to this patient?',
    resetPasswordPatient: '¿Do you want to reset the patient password?',
    patientCreated: 'A new patient have been created',
    patientUpdated: 'A patient have been updated',
    numRequired: 'Number is required',
    typeRequired: 'Type is required',
    clinicHistory: 'Clinic history',
    invite: 'Invite',
    medIndicator: 'Medical indicators',
    status: 'Status',
    activo: 'Activo',
    inactivo: 'Inactivo',
    guest: 'Invitado',
    pending: 'Pendiente',
    invitation: 'A registration invitation has been sent to the patient.',
    alreadyInvited: 'This patient has already been invited.',
    documentType: 'Document type',
    insurance: 'Insurance',
    insuranceCarrier: 'Insurance carrier',
    kidneUnit: 'Kidney unit',
    clinic: 'Clinic',
    modality: 'Modality',
    start_date: 'Start Date',
    patient_status: 'Status',
    end_date: 'End date',
    total_patients: 'Patients Total',
    patient_success: 'Success',
    patient_failed: 'Errors',
    see_details: 'Check Details',
    patientId: 'ID',
    process_date: 'Process Date',
    massive_processing: 'Masive Processing'
  }
};
